import { render, staticRenderFns } from "./RealNameForm.vue?vue&type=template&id=de32d156&"
import script from "./RealNameForm.vue?vue&type=script&lang=ts&"
export * from "./RealNameForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports